import {createReducer, on} from '@ngrx/store';
import {StreamConfiguration} from '../../../services/api/stream-configurations/stream-configuration.model';
import {
  clearStreamConfigurationsState,
  loadStreamConfigurations,
  loadStreamConfigurationsFailure,
  loadStreamConfigurationsSuccess,
  manyStreamConfigurationsDeleted
} from './stream-configurations.load-all.actions';
import {UUID} from '../../../shared/types/uuid.type';
import {deleteStreamConfigurationSuccess} from '../delete/stream-configuration.delete.actions';


export interface State {
  record: StreamConfiguration[];
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const loadAllStreamConfigurationReducer = createReducer(
  initialState,

  on(loadStreamConfigurations, (state: State, _action): State => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true
  })),
  on(loadStreamConfigurationsSuccess, (_state: State, action): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(deleteStreamConfigurationSuccess, (state: State, action: {id: UUID}): State => {
    const id: UUID = action.id;
    const record: StreamConfiguration[] = state.record
      .filter((item: StreamConfiguration): boolean => item.id !== id);
    return {
      record: record,
      error: null,
      loaded: true,
      loading: false
    }
  }),
  on(manyStreamConfigurationsDeleted, (state: State, action: { ids: UUID[] }): State => {
    const ids: UUID[] = action.ids;
    const record: StreamConfiguration[] = state.record.filter((item: StreamConfiguration) => {
      const id: UUID = item.id;
      return !ids.includes(id);
    });
    return {
      record: record,
      loaded: true,
      loading: false,
      error: null
    };
  }),
  on(loadStreamConfigurationsFailure, (_state: State, action): State => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearStreamConfigurationsState, (): State => ({
    record: [],
    error: null,
    loaded: false,
    loading: false
  }))
);
